import { createAsyncThunk } from "@reduxjs/toolkit";
import auditionApi from "api/auditionApi";
import { formatQueryParams } from "helpers/format";

export const getAuditions = createAsyncThunk("Auditions", async (params: any = {}) => {
  try {
    const response = await auditionApi.getAuditions(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

// export const getCompany = async (id: string | number, params: any = {}) => {
//   try {
//     const response = await auditionApi.getCompany(id, params)
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

// export const postCompany = async (data: any = {}) => {
//   try {
//     const response = await companyApi.postCompany(data);
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

// export const putCompany = async (id: string | number, data: any = {}) => {
//   try {
//     const response = await companyApi.putCompany(id, data);
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

// export const getCompaniesByNormal = async (params: any = {}) => {
//   try {
//     const response = await companyApi.companies(formatQueryParams(params))
//     return response;
//   } catch (error) {
//     return error;
//   }
// };